<script>
import Form from '@classes/Form'
import { shareRecordService } from '@/src/services/safehaven/ShareRecordsService'

export default {
  props: {
    group: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      form: new Form({
        recipientName: '',
        recipientEmail: '',
        recipientRelationship: '',
        accessTime: '',
      }),
      shareRecordConfirm: false,

      fnameRule: [
        (v) => !!v || 'First name is required',
        (v) => /^[A-Za-z0-9_ ]+$/g.test(v) || 'Invalid name format',
      ],
      emailRule: [
        (v) => !!v || 'E-mail is required',
        (v) =>
          /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          ) || 'Invalid email address',
      ],
      dropdownRule: [(v) => !!v || 'Field is required'],
      relationship: [],
      howLong: [],
      snackbar: false,
      snackbarMessage: 'Error getting data. Please try again',
    }
  },
  computed: {
    disableBtn() {
      if (
        this.form.recipientName === '' ||
        !/^[A-Za-z0-9_ ]+$/g.test(this.form.recipientName) ||
        this.form.recipientEmail === '' ||
        !/^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          this.form.recipientEmail
        ) ||
        this.form.recipientRelationship === '' ||
        this.form.accessTime === ''
      ) {
        return true
      } else {
        return false
      }
    },
  },

  async mounted() {
    try {
      const dropdownData = await shareRecordService.getRecipientRelationshipDuration()
      this.relationship = dropdownData.data.Relationship
      this.howLong = dropdownData.data.Duration
    } catch (error) {
      console.warn('error:: ', error)
      this.snackbar = true
    }
  },

  methods: {
    async confirmInfo() {
      try {
        const relationIndex = this.relationship.findIndex(
          (ind) =>
            ind.recipient_relationship === this.form.recipientRelationship
        )
        const durationIndex = this.howLong.findIndex(
          (ind) => ind.duration_days === this.form.accessTime
        )

        const reqObj = {
          recipient_name: this.form.recipientName,
          recipient_email: this.form.recipientEmail,
          relationship: {
            id: this.relationship[relationIndex].id,
            recipient_relationship: this.form.recipientRelationship,
          },
          duration: {
            id: this.howLong[durationIndex].id,
            duration_view: this.howLong[durationIndex].duration_view,
            duration_days: this.form.accessTime,
          },
        }
        this.$emit('confirmInfo')
        this.$emit('recipientInfo', reqObj)
      } catch (error) {
        console.warn('error:: ', JSON.stringify(error))
      }
    },
    closeDialog() {
      this.$emit('closeDialog', false)
      setTimeout(() => {
        this.selected = null
      }, 500)
    },
    goBack() {
      this.$emit('backClick', false)
    },
    validate() {
      this.$refs.form.validate()
    },
  },
}
</script>

<template>
  <v-container class="pa-0">
    <v-card :class="$style.cardClass">
      <v-card-text class="pt-0">
        <!-- close button -->
        <div class="mt-4">
          <div :class="$style.closeButtonDiv">
            <v-btn
              color="offblack"
              :class="$style.closeButton"
              icon
              @click="closeDialog"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </div>
          <div
            class="pa-4 pl-2 clickable primary--text"
            :class="$style.backRouterLinkText"
            @click="goBack"
          >
            <v-icon color="primary" class="mb-1">mdi-chevron-left</v-icon>Back
          </div>
        </div>

        <!-- card dialog -->
        <template>
          <v-form
            ref="form"
            lazy-validation
            :class="$style.form"
            @submit.prevent="validate"
          >
            <v-row justify="center" class="pl-4 pr-3">
              <v-col cols="12" md="10" sm="10" class="py-0 mt-10">
                <v-row class="mt-4">
                  <p :class="$style.headText">Your recipient’s information</p>
                </v-row>

                <v-row class="mt-2 py-0 pb-0">
                  <p :class="$style.subheadText"
                    >We’ll email this recipient a personalized invite with a
                    temporary link to your health records.</p
                  >
                </v-row>
                <v-row>
                  <v-col cols="12" md="12" class="py-1 px-0">
                    <label
                      >Recipient’s name<span :class="$style.mandatory"
                        >*</span
                      ></label
                    >
                    <v-text-field
                      v-model="form.recipientName"
                      hide-details="auto"
                      :maxlength="60"
                      :rules="fnameRule"
                      outlined
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="12" class="py-1 px-0">
                    <label
                      >Recipient's email address<span :class="$style.mandatory"
                        >*</span
                      ></label
                    >
                    <v-text-field
                      v-model="form.recipientEmail"
                      hide-details="auto"
                      :rules="emailRule"
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12" class="py-1 px-0">
                    <label
                      >Relationship to you<span :class="$style.mandatory"
                        >*</span
                      ></label
                    >
                    <v-select
                      v-model="form.recipientRelationship"
                      hide-details="auto"
                      outlined
                      :rules="dropdownRule"
                      :items="relationship"
                      item-text="recipient_relationship"
                      item-value="recipient_relationship"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12" class="py-1 px-0">
                    <label
                      >Allow access to my record for<span
                        :class="$style.mandatory"
                        >*</span
                      ></label
                    >
                    <v-select
                      v-model="form.accessTime"
                      hide-details="auto"
                      outlined
                      :rules="dropdownRule"
                      :items="howLong"
                      item-text="duration_view"
                      item-value="duration_days"
                    ></v-select>
                  </v-col>
                </v-row>

                <!-- get started button -->
                <v-row no-gutters align="center" justify="center" class="mt-4">
                  <v-btn
                    class="mt-4"
                    :class="[
                      'primary-btn',
                      $style.reviewButton,
                      disableBtn && 'disabled-btn',
                    ]"
                    elevation="0"
                    width="236"
                    height="37"
                    @click="confirmInfo"
                    >Next: Review and share</v-btn
                  >
                </v-row>
              </v-col>
            </v-row>
          </v-form>
        </template>
      </v-card-text>
    </v-card>
    <v-snackbar
      v-model="snackbar"
      content-class="body--text"
      height="65"
      color="background"
      :timeout="3000"
    >
      <div class="d-flex">
        <v-icon color="#ee6363" class="my-auto">mdi-close-circle</v-icon>
        <div class="my-auto ml-3">
          {{ snackbarMessage }}
        </div>
      </div>

      <template v-slot:action="{ attrs }">
        <v-btn icon color="body" text v-bind="attrs" @click="snackbar = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';

.cardClass {
  height: 750px;
  color: #fff;
}
.closeButton {
  position: absolute;
  top: 16px;
  right: 0;
  padding-left: 0;
}
.closeButtonDiv {
  position: relative;
}
.backRouterLinkText {
  position: absolute;
  left: 0;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  color: #0476d9;
  letter-spacing: 0.75px;
}
.headText {
  display: flex;
  align-items: center;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  color: #454648;
}

.subheadText {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  color: #454648;
}

.mandatory {
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  color: #da1414;
}

.form label {
  display: inline-block;
  margin-bottom: 10px;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  color: #454648;
  letter-spacing: 0.2px;
}

.reviewButton {
  align-items: center !important;
  justify-content: center !important;
  width: 350px !important;
  height: 50px !important;
  text-transform: inherit !important;
  background: #0476d9;
  border-radius: 30px;
}

@media screen and (max-width: 1263px) {
  .reviewButton {
    top: 270px;
    width: 340px !important;
    height: 50px !important;
  }
}
@media screen and (max-width: 960px) {
  .reviewButton {
    top: 270px;
  }
  .headText {
    margin-top: 8px !important;
  }
  .subheadText {
    align-items: center !important;
    margin-left: 0 !important;
  }
  .cardClass {
    height: 1000px;
  }
}
@media screen and (max-width: 599px) {
  .reviewButton {
    top: 250px;
    width: 340px !important;
    height: 50px !important;
  }
}
</style>

<style scoped>
/deep/.theme--light.v-select .v-select__selections {
  font-size: 12px;
}
/deep/ .v-select__selection--comma {
  font-size: 12px;
}
/deep/ .theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
  background-color: #93c0e8 !important;
}
</style>
